import { render, staticRenderFns } from "./Visualizar.vue?vue&type=template&id=35246fca&scoped=true&"
import script from "./Visualizar.vue?vue&type=script&lang=js&"
export * from "./Visualizar.vue?vue&type=script&lang=js&"
import style0 from "./Visualizar.vue?vue&type=style&index=0&id=35246fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35246fca",
  null
  
)

export default component.exports